module.exports = __webpack_public_path__ + "img/guangGong5.71b3316a.png";